import {BillingDecisionDetails} from "./BillingDecisionDetails";
import type {TicketCostBillingLocation} from "./ticket-cost-types";

export type TicketBillingLocationDetailsProps = {
  location: TicketCostBillingLocation;
};

export const formatTicketBillingAfe = (location: TicketCostBillingLocation) => [location.afePrefix, location.afe, location.afeSuffix].filter(Boolean).join(" ");

/** Resolved billing-location context using the same location, type, expenditure code, and source concepts as BillingLocationInfo. */
export const TicketBillingLocationDetails = ({location}: TicketBillingLocationDetailsProps) => {
  const afe = formatTicketBillingAfe(location);
  const fields = [
    ["Location", (location.id && location.decisionTrace?.entityNames?.[location.id]) || location.name],
    ["Type", location.type],
    ["Billing side", location.billingSide ? `${location.billingSide[0]?.toUpperCase()}${location.billingSide.slice(1)}` : undefined],
    ["Expenditure code", afe || undefined],
    ["Expenditure code source", location.afeSourceLabel],
    ["Mapped from", location.mappedFrom],
  ].filter((field): field is [string, string] => Boolean(field[1]));

  return (
    <div>
      <dl className="grid gap-x-6 gap-y-2 text-xs sm:grid-cols-2 lg:grid-cols-3">
        {fields.map(([label, value]) => (
          <div key={label}>
            <dt className="text-[10px] uppercase tracking-wide text-[var(--ots-text-muted)]">{label}</dt>
            <dd className="mt-0.5 font-medium text-[var(--ots-text)]">{value}</dd>
          </div>
        ))}
      </dl>
      {location.resolution && (
        <div className="mt-3 border-l-2 border-[var(--ots-primary)] pl-3 text-[11px] text-[var(--ots-text-muted)]">
          <span className="font-semibold text-[var(--ots-text)]">Resolution:</span> {location.resolution}
        </div>
      )}
      {location.decisionTrace && <BillingDecisionDetails trace={location.decisionTrace} />}
    </div>
  );
};
